<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Manage Files</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    class="dialog-close-button"
    (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <app-files-list [files]="files" (changedFiles)="onUpdateFiles($event)"></app-files-list>
</mat-dialog-content>
